module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('mini-calculator-page', [_c('div', {
    class: {
      'flex-grid--vertical': !_vm.isValid
    },
    attrs: {
      "slot": "summary-panel"
    },
    slot: "summary-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results a-form-inputs u-full-width u-margin-auto"
  }, [_c('mini-calculator-header', {
    attrs: {
      "title": "Inflation Calculator",
      "icon": "inflation-calculator"
    }
  }), _vm._v(" "), _c('control', {
    attrs: {
      "for": "amount",
      "label": "Amount",
      "before-after": "pound"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.amount),
      expression: "amount"
    }, {
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    ref: "amount",
    attrs: {
      "autocomplete": "off",
      "min": "1",
      "before-after": "pound",
      "type": "text"
    },
    domProps: {
      "value": (_vm.amount)
    },
    on: {
      "focus": function($event) {
        _vm.amount = _vm.amount || ''
      },
      "blur": function($event) {
        _vm.amount = _vm.amount || 0
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.amount = $event.target.value
      }
    }
  }), _vm._v(" "), _c('control-error', {
    attrs: {
      "show": _vm.$error('amount')
    }
  }, [_vm._v("\n                    The amount must be at least £1.00\n                ")])], 1), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Date From"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs a-form-inputs--half-calcs"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minYear),
      expression: "minYear"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.minYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Year")]), _vm._v(" "), _vm._l((_vm.rpiYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.minMonth),
      expression: "minMonth"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.minMonth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Month")]), _vm._v(" "), _vm._l((12), function(month) {
    return _c('option', {
      domProps: {
        "value": month
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.monthToString(month)) + "\n                            ")])
  })], 2)])])]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Date To"
    }
  }, [_c('div', {
    staticClass: "a-form-inputs a-form-inputs--half-calcs"
  }, [_c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxYear),
      expression: "maxYear"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.maxYear = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Year")]), _vm._v(" "), _vm._l((_vm.toYears), function(year) {
    return _c('option', {
      domProps: {
        "value": year
      }
    }, [_vm._v(_vm._s(year))])
  })], 2)]), _vm._v(" "), _c('div', {
    staticClass: "a-form-inputs__container"
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxMonth),
      expression: "maxMonth"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.maxMonth = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "disabled": "",
      "hidden": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("Month")]), _vm._v(" "), _vm._l((_vm.toMonths), function(month) {
    return _c('option', {
      domProps: {
        "value": month
      }
    }, [_vm._v("\n                                " + _vm._s(_vm.monthToString(month)) + "\n                            ")])
  })], 2)])]), _vm._v(" "), _c('control-error', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.toMonths.length === 0),
      expression: "toMonths.length === 0"
    }]
  }, [_vm._v("\n                    Date To must be after Date From\n                ")])], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isValid),
      expression: "isValid"
    }]
  }, [_c('h2', [_vm._v("\n                    Result\n                ")]), _vm._v(" "), _c('control', {
    attrs: {
      "label": _vm.monthToString(_vm.minMonth) + ' ' + _vm.minYear,
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.amount, '')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": _vm.monthToString(_vm.maxMonth) + ' ' + _vm.maxYear,
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.equivalent, '')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Difference",
      "before-after": "pound-on-dark"
    }
  }, [_c('input', {
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.currencyFormat(_vm.difference, '')
    }
  })]), _vm._v(" "), _c('control', {
    attrs: {
      "label": "Difference",
      "before-after": "percent-on-dark"
    }
  }, [_c('input', {
    directives: [{
      name: "two-dp",
      rawName: "v-two-dp"
    }],
    attrs: {
      "autocomplete": "off",
      "disabled": "",
      "type": "text"
    },
    domProps: {
      "value": _vm.percentageDifference(_vm.amount, _vm.equivalent)
    }
  })])], 1)], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "results-panel"
    },
    slot: "results-panel"
  }, [_c('div', {
    staticClass: "p-animated-calc__results-panel u-full-width u-margin-auto"
  }, [_c('h2', [_vm._v("Explanation")]), _vm._v(" "), _c('p', [_vm._v("\n                The inflation calculator can be used to show how the cost of goods and services\n                has changed over time.\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                Using the Retail Price Index (RPI) data sourced from the Office For National Statistics (ONS),\n                the calculator has determined that\n                " + _vm._s(_vm.currencyFormat(_vm.amount)) + " in " + _vm._s(_vm.monthToString(_vm.minMonth)) + " " + _vm._s(_vm.minYear) + "\n                would be the equivalent of\n                " + _vm._s(_vm.currencyFormat(_vm.equivalent)) + " in " + _vm._s(_vm.monthToString(_vm.maxMonth)) + " " + _vm._s(_vm.maxYear) + ".\n            ")]), _vm._v(" "), _c('p', [_vm._v("\n                That's a difference of " + _vm._s(_vm.currencyFormat(_vm.difference)) + "\n                (" + _vm._s(_vm.roundValue(_vm.percentageDifference(_vm.equivalent, _vm.amount), 2)) + "%)\n                during the period of " + _vm._s(_vm.startToEnd) + "."), _c('br'), _c('br')]), _vm._v(" "), _c('h3', [_vm._v("\n                Visual comparison of inflation applied to " + _vm._s(_vm.currencyFormat(_vm.amount)) + "\n            ")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('value-bars', {
    attrs: {
      "values": _vm.barValues
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.monthToString(_vm.minMonth)) + " " + _vm._s(_vm.minYear))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar1"
  }, [_c('span')]), _vm._v(" "), _c('h3', [_vm._v(_vm._s(_vm.monthToString(_vm.maxMonth)) + " " + _vm._s(_vm.maxYear))]), _vm._v(" "), _c('div', {
    staticClass: "m-bars__bar bar2"
  }, [_c('span')])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h2', [_vm._v("Calculation")]), _vm._v(" "), _c('p', [_vm._v("\n                The value of inflation was calculated using the following formula:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "m-formula"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [_vm._v("\n                        ([£ Value] / [RPI @ Start]) x [RPI @ End] = [£ Value at End]\n                    ")])])]), _vm._v(" "), _c('p', [_vm._v("\n                Which was populated with the RPI data sourced from the ONS to determine the value:\n            ")]), _vm._v(" "), _c('div', {
    staticClass: "m-formula u-margin-bottom-20"
  }, [_c('div', {
    staticClass: "m-formula__item--row"
  }, [_c('strong', [_vm._v("\n                        ( " + _vm._s(_vm.currencyFormat(_vm.amount)) + " / " + _vm._s(_vm.getRpiForDate(_vm.minYear, _vm.minMonth)) + " ) x " + _vm._s(_vm.getRpiForDate(_vm.maxYear, _vm.maxMonth)) + " = " + _vm._s(_vm.currencyFormat(_vm.equivalent)) + "\n                    ")])])])], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73c04fcc!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/mini-calculators/calculators/inflationCalculator.vue
// module id = 1744
// module chunks = 0